export default () => ({
  name: '',
  fullPath: ''
})
